import React, { useEffect, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FitzaaLoader } from './FitzaaLoader';

const AzureADCallback: React.FC = memo(() => {
  const navigate = useNavigate();
  const { isLoading, isAuthenticated, user } = useAuth();

  useEffect(() => {
    console.log('[AzureADCallback] Component mounted');
    console.log('[AzureADCallback] Current URL:', window.location.href);
    console.log('[AzureADCallback] Pathname:', window.location.pathname);
    console.log('[AzureADCallback] Hash:', window.location.hash);

    // This component will be rendered when Azure AD redirects back
    // The actual authentication logic is handled in AuthContext's useEffect
    // We just need to show a loading state and let AuthContext handle the redirect

    // If already authenticated, redirect immediately
    if (isAuthenticated && user) {
      console.log('[AzureADCallback] Already authenticated, redirecting to home');
      navigate('/home');
      return;
    }

    const timer = setTimeout(() => {
      // If still loading after 5 seconds, redirect to home
      if (isLoading) {
        console.log('[AzureADCallback] Timeout reached, redirecting to home');
        navigate('/home');
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, isLoading, isAuthenticated, user]);

  console.log('[AzureADCallback] Rendering component');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Completing Sign In...
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Please wait while we complete your authentication.
          </p>
        </div>
        <div className="flex justify-center">
          <FitzaaLoader size="small" message="Completing authentication..." />
        </div>
      </div>
    </div>
  );
});

AzureADCallback.displayName = 'AzureADCallback';

export default AzureADCallback; 